import { render, staticRenderFns } from "./CityIndex.vue?vue&type=template&id=1dfe4a8a&scoped=true"
import script from "./CityIndex.vue?vue&type=script&lang=js"
export * from "./CityIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe4a8a",
  null
  
)

export default component.exports